export default __webpack_public_path__ + "static/media/2_Cat_God.be27ffa9.png";